module.exports = __webpack_public_path__ + "static/media/566ee31c-f92a-4c15-9d0f-b806191506a4.ba89da20.webp";